const normalizeBooleanFlag = value => {
  if (value === true || value === 'true' || value === 1 || value === '1') {
    return true;
  }

  if (value === false || value === 'false' || value === 0 || value === '0') {
    return false;
  }

  return null;
};

export const isInfiniteScrollDebugEnabled = () => {
  const envFlag =
    typeof process !== 'undefined' ? normalizeBooleanFlag(process.env.DEBUG_INFINITE_SCROLL) : null;
  if (envFlag === true) {
    return true;
  }

  if (typeof window === 'undefined') {
    return false;
  }

  return normalizeBooleanFlag(window['__DEBUG_INFINITE_SCROLL__']) === true;
};

export const debugInfiniteScroll = (eventName, payload = {}) => {
  if (!isInfiniteScrollDebugEnabled()) {
    return;
  }

  // eslint-disable-next-line no-console
  console.log(`[inf-scroll] ${eventName}`, payload);
};
